module.exports = __webpack_public_path__ + "img/anna-kazmierczak.949b8b40.png";